import guestRoutes from './guest.routes';

import guestAdditionController from './controllers/guest.addition.controller';
import guestEditController from './controllers/guest.edit.controller';
import promptController from './controllers/prompt.controller';

import guestAdditionComponent from './components/guest.addition.component';
import guestEditComponent from './components/guest.edit.component';
import guestPageComponent from './components/guest.page.component';

import promptService from './services/prompt.service';
import guestApiService from './services/guest.api.service';

let guestModule = angular.module('spabooker.guest', ['ngAnimate'])
    .config(guestRoutes)

    .controller('guestAdditionController', guestAdditionController)
    .controller('guestEditController', guestEditController)
    .controller('promptController', promptController)

    .component('guestAddition', guestAdditionComponent)
    .component('guestEdit', guestEditComponent)
    .component('guestPage', guestPageComponent)

    .factory('prompt', promptService)
    .factory('guestApi', guestApiService)
    ;
export default guestModule.name;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/index.js